const INITIAL_STATE = {
    offlineEvents: [],
    count: 0,
    loading: false
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case "GET_OFFLINE_EVENTS": {
        return {
          ...state,
          offlineEvents: action.offlineEvents,
          count: action.count,
          loading: false
        }
      }
      default:
        return state
    }
  }
  